import React from 'react'

import { DocumentImageArchiveList } from './components/DocumentImageArchiveList'

export const DocumentImageArchiveListPage = () => <DocumentImageArchiveList />
